export const CONTROL_TYPE = {
    TEXT: "text",
    DROPDOWN: "select",
    RADIO: "radio",
    TEXTAREA: "textarea",
    PASSWORD: "password"
}

export const INSTALL_TYPE = {
    SINGLE: "FULL",
    DISTRIBUTED: "DISTRIBUTED"
}

export const UPLOAD_STATUS = {
    UPLOADING: "uploading",
    ERROR: "error",
    DONE: "done",
}